import { addMilliseconds, format } from 'date-fns'
import { useAtom } from 'jotai'

import { moveBookingDialogAtom } from '../../../atoms/calendar'
import { useBookings } from '../../../hooks/useBookings'
import { useCalendar } from '../../../hooks/useCalendar'

import MoveBookingDialogFooter from './MoveBookingDialogFooter'

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'

const MoveBookingDialog = () => {
  const [state, setState] = useAtom(moveBookingDialogAtom)
  const { refetchResources } = useCalendar()

  const { update, isUpdating } = useBookings()

  const handleClose = () => {
    refetchResources()
    setState({ open: false })
    state.onCancel?.()
  }

  const handleSubmit = (mail?: boolean) => {
    if (!state.open) return

    if (state.kind === 'time') {
      const newBooking = {
        ...state.booking,
        from: addMilliseconds(state.booking.from, state.timeDifference),
        until: state.booking.until && addMilliseconds(state.booking.until, state.timeDifference),
      }
      update(newBooking, mail ?? false, 'occurrence', handleClose)
    } else if (state.kind === 'assignTable' || state.kind === 'clearTables') {
      state.onConfirm()
      handleClose()
    }
  }

  return (
    <Dialog open={state.open} onOpenChange={(open) => !open && handleClose()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>
            {state.open &&
              (state.kind === 'time'
                ? 'Reservierung verschieben?'
                : state.kind === 'clearTables'
                  ? 'Tischzuweisungen entfernen?'
                  : 'Tisch zuweisen?')}
          </DialogTitle>
          <DialogDescription>
            {state.open &&
              (state.kind === 'time' ? (
                <>
                  Du hast die Reservierung von{' '}
                  <b>{format(state.booking.from, 'dd.MM.yyyy HH:mm')}</b> auf{' '}
                  <b>
                    {format(
                      addMilliseconds(state.booking.from, state.timeDifference),
                      'dd.MM.yyyy HH:mm'
                    )}
                  </b>{' '}
                  verschoben. Möchtest du das wirklich tun?
                </>
              ) : state.kind === 'clearTables' ? (
                'Sie verschieben die Reservierung in den Raum und verlieren damit alle Tischzuweisungen. Fortfahren?'
              ) : state.kind === 'newRoom' ? (
                'Die Reservierung befindet sich nun in einem anderen Raum - alle vorherigen Tische gehen verloren. Fortfahren?'
              ) : (
                'Die Reservierung hatte zuvor keine Tischzuweisung. Möchtest du den Tisch jetzt zuweisen?'
              ))}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <MoveBookingDialogFooter
            onSubmit={handleSubmit}
            onDecline={handleClose}
            loading={isUpdating}
            kind={state.kind}
          />
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}

export default MoveBookingDialog
